import * as React from "react";
import { useCallback } from "react";
import "./index.css";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export const useContainerDimensions = (myRef) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const getDimensions = () => {
      if (!myRef.current) return { width: 0, height: 0 };

      const { width, height } = myRef.current.getBoundingClientRect();
      return {
        width: Math.round(width),
        height: Math.round(height),
      };
    };

    const handleResize = () => {
      setDimensions(getDimensions());
    };

    if (myRef.current) {
      setDimensions(getDimensions());
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [myRef]);

  return dimensions;
};

export const AzilisSwitch = React.memo(
  ({ choice1 = "Yes", choice2 = "No", styleNo, which, setWhich, disabled }) => {
    const containerRef = useRef(null);
    const { width } = useContainerDimensions(containerRef);
    const { t } = useTranslation();

    const handleClick = useCallback(
      (value) => {
        if (!disabled) {
          setWhich(value);
        }
      },
      [setWhich, disabled]
    );

    const optionWidth = width / 2;

    return (
      <div
        className={`azilisswitch azilisswitch__style${styleNo}`}
        ref={containerRef}
      >
        <div
          className="azilisswitch__thumb"
          style={{
            width: `${optionWidth}px`,
            left: which === choice2 ? `${optionWidth}px` : "0px",
          }}
        ></div>
        <div
          className="azilisswitch__first"
          onClick={() => handleClick(choice1)}
        >
          <h4 id="switchtext">{t(choice1)}</h4>
        </div>
        <div
          className="azilisswitch__second"
          onClick={() => handleClick(choice2)}
        >
          <h4 id="switchtext">{t(choice2)}</h4>
        </div>
      </div>
    );
  }
);
export const AzilisSwitch2 = React.memo(
  ({
    choice1 = "Yes",
    choice2 = "No",
    value1 = "Yes",
    value2 = "No",
    styleNo,
    which,
    setWhich,
  }) => {
    const widthRef = useRef(null);
    const { width } = useContainerDimensions(widthRef);

    const handleClick = useCallback(
      (value) => {
        setWhich(value);
      },
      [setWhich]
    );

    return (
      <div className={`azilisswitch azilisswitch__style${styleNo}`}>
        <p
          style={{
            position: "relative",
            height: "100%",
            transition: "left 0.2s",
            left: which === value2 ? `${width}px` : "0px",
          }}
        >
          <div
            className="azilisswitch__thumb"
            style={{ width: `${width}px` }}
          ></div>
        </p>
        <div
          ref={widthRef}
          className="azilisswitch__first"
          onClick={() => handleClick(value1)}
        >
          <h4 style={{ color: "#F2F8F0" }} id="switchtext">
            {choice1}
          </h4>
        </div>
        <div
          className="azilisswitch__second"
          onClick={() => handleClick(value2)}
        >
          <h4 style={{ color: "#F2F8F0" }} id="switchtext">
            {choice2}
          </h4>
        </div>
      </div>
    );
  }
);

export const AzilisSwitch3 = React.memo(
  ({
    choice1 = "Option 1",
    choice2 = "Option 2",
    choice3 = "Option 3",
    value1 = "option1",
    value2 = "option2",
    value3 = "option3",
    styleNo = 1,
    which,
    setWhich,
    disabled = false,
  }) => {
    const containerRef = useRef(null);
    const { width } = useContainerDimensions(containerRef);
    const { t } = useTranslation();

    const handleClick = useCallback(
      (value) => {
        if (!disabled) {
          setWhich(value);
        }
      },
      [setWhich, disabled]
    );

    useEffect(() => {
      if (which === null || which === undefined) {
        setWhich(choice1);
      }
    }, [choice1, setWhich, which]);

    const getThumbPosition = useCallback(() => {
      const optionWidth = width / 3;
      switch (which) {
        case value1:
          return 0;
        case value2:
          return optionWidth;
        case value3:
          return optionWidth * 2;
        default:
          return 0;
      }
    }, [value1, value2, value3, width, which]);

    return (
      <div
        className={`azilisswitch azilisswitch__style${styleNo}`}
        ref={containerRef}
      >
        <div
          className="azilisswitch__thumb"
          style={{
            left: `${getThumbPosition()}px`,
            width: `${width / 3}px`,
          }}
        ></div>
        <div
          className="azilisswitch__option"
          onClick={() => handleClick(value1)}
        >
          <h4>{t(choice1)}</h4>
        </div>
        <div
          className="azilisswitch__option"
          onClick={() => handleClick(value2)}
        >
          <h4>{t(choice2)}</h4>
        </div>
        <div
          className="azilisswitch__option"
          onClick={() => handleClick(value3)}
        >
          <h4>{t(choice3)}</h4>
        </div>
      </div>
    );
  }
);

export default AzilisSwitch3;
